<template>
    <div>
        <wap-header></wap-header>
        <div style="background: #ffffff;text-align: left;width:355px;height:100%;overflow: auto;margin:55px auto 0;font-size: 18px;">
            <div v-html="obj.htmls" id="details"></div>
        </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    export default {
        name: "wapInformationDetail",
        components: {wapHeader, wapFooter},
        data(){
            return{
                obj:{htmls:''}
            }
        },
        mounted() {
            this.getData(this.$route.query.id)
        },
        methods:{
            // btn_buto() {
            //     this.$router.push('/')
            // },
            // btn_buso() {
            //     this.$router.push('/InformationDynamics')
            // },
            // btn_buao(type) {
            //     this.$router.push('/InformationDynamics?type='+type)
            // },
            getData(id){
                const newEnergy = this.newEnergy = require('../../../assets/JSONData/wapInformation/company.json');
                const nitrileCompound = this.nitrileCompound = require('../../../assets/JSONData/wapInformation/InformationDynamics.json');
                let list = [];
                list = list.concat(newEnergy);
                list = list.concat(nitrileCompound)
                for (let i in list) {
                    if (list[i].id == id) {
                        this.obj = list[i];
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>
